import React, { Component } from "react";
import { createPortal } from "react-dom";
import Swal from "sweetalert2";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
const tokens = localStorage.getItem("ptn-acc-tk") || "";
const twofa = localStorage.getItem("ptn-2fa") || "";
const safeParseJSON = (value) => {
  if (!value || value === "undefined" || value === "null") return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};
const profile = safeParseJSON(localStorage.getItem("ptn-profile"));
const mode = localStorage.getItem("mode") || "light";
const required = <span className="text-danger">*</span>;
const linkRole = (user_type) => {
  return user_type === "super_user"
    ? "su"
    : user_type === "admin"
    ? "ad"
    : user_type === "accounting"
    ? "ac"
    : "pb";
};
const StatusTnx = (status) => {
  return status === "pending"
    ? Status("pending", "warning")
    : status === "success"
    ? Status("success", "success")
    : status === "mismatch"
    ? Status("mismatch", "purple")
    : status === "cancel"
    ? Status("cancel", "danger")
    : status === "pending-refund"
    ? Status("pending refund", "pink")
    : status === "refund"
    ? Status("refund", "info")
    : null;
};
const CreateToken = () => {
  try {
    const now = new Date();
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + 1, now.getSeconds());
    const hex = process.env.REACT_APP_CODE_HEX?.split("|") || [];
    const code = endOfDay.getTime().toString();

    let result = "";
    for (let i = 0; i < code.length; i++) {
      const digit = parseInt(code[i], 10);
      const chars = hex[digit];
      const randomChar = chars[Math.floor(Math.random() * chars.length)];
      result += randomChar;
    }
    return result;
  } catch (err) {
    return "";
  }
};
const getAccessToken = () => {
  try {
    const latestToken = localStorage.getItem("ptn-acc-tk") || "";
    return latestToken ? atob(latestToken) : "";
  } catch (err) {
    return "";
  }
};
// backend ต่ออายุ token ให้ตอนใบเดิมหมดอายุ แล้วส่งใบใหม่กลับมาทาง header
// ถ้าไม่เก็บทับ ใบเก่าใน localStorage จะไม่ตรงกับใน DB แล้ว request ถัดไปจะโดน Invalid token
const REFRESH_TOKEN_HEADER = "x-refresh-token";
const saveRefreshedToken = (refreshedToken) => {
  try {
    if (refreshedToken) {
      localStorage.setItem("ptn-acc-tk", btoa(`Bearer ${refreshedToken}`));
    }
  } catch (err) {
    // เก็บ token ใหม่ไม่ได้ก็ปล่อยผ่าน ไม่ควรทำให้ request พัง
  }
};

// อ่าน payload ของ JWT ที่ถืออยู่ (ไม่ตรวจลายเซ็น แค่เอา exp/iat มาตั้งเวลาต่ออายุ)
const decodeTokenPayload = () => {
  try {
    const raw = getAccessToken().replace(/^Bearer\s+/i, "");
    const part = raw.split(".")[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (err) {
    return null;
  }
};

// ต่ออายุล่วงหน้าเมื่อเหลืออายุไม่ถึงค่านี้ (ไม่เกินครึ่งหนึ่งของอายุใบ) จะได้ไม่ต้องรอให้หมดอายุแล้วค่อยหมุนผ่าน header
const TOKEN_REFRESH_BEFORE_MS = 24 * 60 * 60 * 1000;
const TOKEN_REFRESH_CHECK_INTERVAL_MS = 60 * 1000;
let refreshInFlight = null;
let refreshTimer = null;

const shouldRefreshToken = () => {
  const payload = decodeTokenPayload();
  if (!payload?.exp) return false;

  const expiresAt = payload.exp * 1000;
  const lifetime = payload.iat ? expiresAt - payload.iat * 1000 : 0;
  const threshold = lifetime > 0 ? Math.min(TOKEN_REFRESH_BEFORE_MS, lifetime / 2) : TOKEN_REFRESH_BEFORE_MS;

  return expiresAt - Date.now() <= threshold;
};

// ขอใบใหม่ของ session เดิมจาก backend รวมคำขอที่ซ้อนกันให้เหลือครั้งเดียว
// ล้มเหลวเพราะ network/server จะเงียบ ๆ แล้วลองใหม่รอบถัดไป ส่วน 401 จะถูกจัดการใน handleApiFailure ตามปกติ
const refreshAccessToken = () => {
  if (refreshInFlight) return refreshInFlight;
  if (!getAccessToken()) return Promise.resolve(false);

  refreshInFlight = POST("v1/auth/refresh-token", {}, null, { silent: true })
    .then((result) => {
      if (result?.status === true && result?.data?.token) {
        saveRefreshedToken(result.data.token);
        return true;
      }
      return false;
    })
    .catch(() => false)
    .finally(() => {
      refreshInFlight = null;
    });

  return refreshInFlight;
};

// เริ่มตัวจับเวลาต่ออายุ token อัตโนมัติ เรียกได้หลายครั้ง (เช่นจากทุกหน้า) จะมีตัวจับเวลาแค่ตัวเดียว
const startTokenRefreshScheduler = () => {
  if (refreshTimer) return;

  const tick = () => {
    if (!getAccessToken()) return;
    if (shouldRefreshToken()) refreshAccessToken();
  };

  tick();
  refreshTimer = setInterval(tick, TOKEN_REFRESH_CHECK_INTERVAL_MS);

  // กลับมาที่แท็บหลังพักเครื่อง ตัวจับเวลาอาจไม่ได้เดิน ให้เช็คทันที
  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") tick();
    });
  }
};
const preserveClientPrefs = () => {
  const mode = localStorage.getItem("mode") || "light";
  const rememberedEmail = localStorage.getItem("ptn-remember-email");

  localStorage.clear();
  localStorage.setItem("mode", mode);

  if (rememberedEmail) {
    localStorage.setItem("ptn-remember-email", rememberedEmail);
  }
};
const isUnauthorizedResponse = (result, message) => {
  return (
    result?.status === 401 ||
    message === "Token not found" ||
    message === "Token has expired" ||
    message === "Invalid token" ||
    message === "Authorization header missing"
  );
};
// ล้าง localStorage เฉพาะตอน API ตอบ 401 เท่านั้น
// network error / server error (5xx) จะแค่แจ้งเตือน ไม่ล้าง session ของผู้ใช้ทิ้ง
// options.silent = ไม่เด้ง alert ให้ผู้เรียกจัดการเอง (ใช้กับหน้า login และการต่ออายุ token เบื้องหลัง)
const handleApiFailure = (result, resolve, options) => {
  const message = ERROR(result) || "An error occurred. Please try again.";
  const silent = !!options?.silent;

  if (isUnauthorizedResponse(result, message)) {
    preserveClientPrefs();
    if (!silent) alert("/", "warning", "แจ้งเตือน", message, "ปิด");
    resolve({ status: false, message, status_code: 401 });
    return;
  }

  if (message === "fetch is not defined") {
    if (!silent) alert("", "warning", "แจ้งเตือน", "ไม่พบข้อมูล");
    resolve({ status: false, message });
    return;
  }

  if (!silent) alert("", "warning", "แจ้งเตือน", message);
  resolve({ status: false, message, status_code: result?.status || 500 });
};

// fetch ล้มเหลว (ไม่มีเน็ต / server ล่ม / response ไม่ใช่ JSON) — status_code 0 ให้ผู้เรียกแยกจาก 401 ได้
const networkFailure = () => ({ status: false, message: "Error", status_code: 0, network: true });
const alert = (url, icon, title, detail, confirm, cancel) => {
  // if(confirm){
const modals = document.getElementsByClassName("swal2-modal");
  const icons = document.getElementsByClassName("swal2-icon");

  const hasBangIcon = Array.from(icons).some(
    (el) => el.textContent.trim() === "!"
  );
  if (modals.length >= 2 || hasBangIcon) return;

  return Swal.fire({
    icon: icon || "warning",
    title: title || (icon === "success" ? "สำเร็จ" : "แจ้งเตือน"),
    text:
      detail ||
      (icon === "success"
        ? "ทำรายการสำเร็จแล้ว"
        : " "),
    confirmButtonText: confirm || "ยืนยัน",
    showCancelButton: !!cancel,
    cancelButtonText: cancel || "ยกเลิก",
    background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
    color: mode === "dark" ? "#fff" : "#000000", // Text color
    confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
    cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
  }).then(({ isConfirmed }) => {
    if (url) {
      if (url === "#") window.location.reload();
      else window.location.href = url;
    }
    return isConfirmed;
  });

  // }else{
  //    return Swal.fire({
  //   toast: true,
  //   position: 'top-end',
  //    icon: icon || "warning",
  //   title: title || (icon === "success" ? "Success" : "Warning"),
  //   text:
  //     detail ||
  //     (icon === "success"
  //       ? "The transaction was completed successfully."
  //       : " "),
  //   showConfirmButton: false,
  //   timer: 1500,
  //   timerProgressBar: true,
  //   background: mode === "dark" ? "#000000" : "#fff",
  //   color: mode === "dark" ? "#fff" : "#000000",
  //   didOpen: (toast) => {
  //     toast.addEventListener('mouseenter', Swal.stopTimer)
  //     toast.addEventListener('mouseleave', Swal.resumeTimer)
  //   }
  // }).then(() => {
  //   if (url) {
  //     if (url === "#") window.location.reload();
  //     else window.location.href = url;
  //   }
  // });
  // }
 
  };
const copyText = (textToCopy) => {
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      Swal.fire({
        icon: "success",
        title: "สำเร็จ",
        text: "คัดลอกแล้ว",
        showConfirmButton: false,
        timer: 1500,
        background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
        color: mode === "dark" ? "#fff" : "#000000", // Text color
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
      });
    })
    .catch((err) => {});
};
const total = (array, key) => {
  if (!Array.isArray(array)) return 0;
  return key
    ? array.reduce((sum, item) => Number(sum) + (Number(item[key]) || 0), 0)
    : array.reduce((sum, item) => Number(sum) + (Number(item) || 0), 0);
};
const float = (num, length = 2) => {
  const regexPattern = new RegExp(`^\\d*\\.?\\d{0,${length}}$`);
  return regexPattern.test(num);
};
const toFixed = (number, size = 2, ceil = false) => {
  if (!number && number !== 0) return "0.00";
  if (number === 0) return "0.00";

  const num = Number(number.toString());
  const precision = size || 2;
  const processedNum = ceil
    ? Math.ceil(num * Math.pow(10, precision)) / Math.pow(10, precision)
    : num;

  return processedNum.toFixed(precision).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};
const format_date = (date, format, locale, type_excel) => {
  const array_month =
    locale?.toLowerCase() === "en"
      ? [
          "Jan.",
          "Feb.",
          "Mar.",
          "Apr.",
          "May.",
          "Jun.",
          "Jul.",
          "Aug.",
          "Sep.",
          "Oct.",
          "Nov.",
          "Dec.",
        ]
      : [
          "ม.ค.",
          "ก.พ.",
          "มี.ค.",
          "เม.ย.",
          "พ.ค.",
          "มิ.ย.",
          "ก.ค.",
          "ส.ค.",
          "ก.ย.",
          "ต.ค.",
          "พ.ย.",
          "ธ.ค.",
        ];

  const array_full_month =
    locale?.toLowerCase() === "en"
      ? [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ]
      : [
          "มกราคม",
          "กุมภาพันธ์",
          "มีนาคม",
          "เมษายน",
          "พฤษภาคม",
          "มิถุนายน",
          "กรกฎาคม",
          "สิงหาคม",
          "กันยายน",
          "ตุลาคม",
          "พฤศจิกายน",
          "ธันวาคม",
        ];

  let processedDate = date;
  if (type_excel) {
    if (Number(date)) {
      processedDate = new Date(
        date * 24 * 60 * 60 * 1000 + Date.parse("1899-12-30")
      );
    } else if (typeof date === "string") {
      const separator = date.includes("/")
        ? "/"
        : date.includes(".")
        ? "."
        : null;
      if (separator && date.split(separator)[2]?.length === 4) {
        const [day, month, year] = date.split(separator);
        const adjustedYear =
          Number(year) < 2100 ? Number(year) : Number(year) - 543;
        processedDate = `${adjustedYear}-${("0" + month).slice(-2)}-${(
          "0" + day
        ).slice(-2)}`;
      }
    }
  }

  const new_date = new Date(processedDate);
  if (isNaN(new_date.getTime())) return "-";
  const day = new_date.getDate();
  const month = new_date.getMonth();
  const rawYear = new_date.getFullYear();
  // มาตรฐานของระบบ: แสดงปีเป็น ค.ศ. เสมอ ยกเว้นระบุ locale = "th" มาชัดเจน (เช่น เอกสารที่ต้องใช้ พ.ศ.)
  const year =
    locale?.toLowerCase() === "th"
      ? rawYear > 2100
        ? rawYear
        : rawYear + 543
      : rawYear > 2100
      ? rawYear - 543
      : rawYear;
  const hour = new_date.getHours();
  const minute = new_date.getMinutes();
  const second = new_date.getSeconds();
  if (!format) {
    return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(
      2,
      "0"
    )}/${String(year).padStart(4, "0")}`;
  }

  if (format === "date") {
    return new_date.getTime();
  }
  let formatted = format
    .toLowerCase()
    // Time formats
    .replace(
      /hh:mm:ss/g,
      `${String(hour).padStart(2, "0")}:${String(minute).padStart(
        2,
        "0"
      )}:${String(second).padStart(2, "0")}`
    )
    .replace(
      /hh:mm/g,
      `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`
    )
    .replace(/hh/g, String(hour).padStart(2, "0"))
    .replace(/h:m:s/g, `${hour}:${minute}:${second}`)
    .replace(/h:m/g, `${hour}:${minute}`)
    // Day formats
    .replace(/dd/g, String(day).padStart(2, "0"))
    .replace(/\bd\b/g, day)
    // Month formats
    .replace(/mmmm/g, array_full_month[month])
    .replace(/mmm/g, array_month[month])
    .replace(/\bmm\b/g, String(month + 1).padStart(2, "0"))
    .replace(/\bm\b/g, (month + 1).toString())
    // Year formats
    .replace(/yyyy/g, String(year).padStart(4, "0"))
    .replace(/yyy/g, year.toString().slice(-3))
    .replace(/\byy\b/g, year.toString().slice(-2))
    .replace(/\by\b/g, year);

  return formatted || "";
};
// ตัดคีย์ที่เป็น "" หรือ null ออกจาก body ก่อนส่ง
// ถ้าต้องการส่งค่าว่างขึ้นไปจริง ๆ (เช่นล้างค่าที่เคยกรอกไว้) ให้ส่ง option keepEmpty: true
function removeEmptyString(value) {
  // Array
  if (Array.isArray(value)) {
    const arr = value
      .map(removeEmptyString)
      .filter(v => v !== "" && v !== null);

    return arr.length > 0 ? arr : null;
  }

  // Object
  if (value && typeof value === "object") {
    const obj = Object.fromEntries(
      Object.entries(value)
        .map(([k, v]) => [k, removeEmptyString(v)])
        .filter(([_, v]) => v !== "" && v !== null)
    );

    return Object.keys(obj).length > 0 ? obj : null;
  }

  return value;
}


// extraHeaders: ใช้ส่ง x-vault-token (ตั๋ว TOTP อายุสั้น) ของหน้าห้องนิรภัย ENV
const GET = async (url, body, extraHeaders, options) => {
  return new Promise((resolve) => {
    let queryString = "";
    if (body) {
      queryString =
        "?" +
        Object.entries(body)
          .map(([key, value]) => `${key}=${value}`)
          .join("&");
    }
    const apiUrl = url.includes("://") ? url :
      (process.env.REACT_APP_API_URL + url).replaceAll(" ", "") + queryString;

    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: getAccessToken(),
        token: CreateToken(),
        ...(extraHeaders || {}),
      },
      cache: "no-cache",
    })
      .then((response) => {
        saveRefreshedToken(response.headers.get(REFRESH_TOKEN_HEADER));
        return response.json();
      })
      .then((result) => {
        if (result.status === true) {
          resolve(result);
          return;
        }
        handleApiFailure(result, resolve, options);
      })
      .catch(() => {
        resolve(networkFailure());
      });
  });
};
// fetch รายงานความคืบหน้าการอัปโหลดไม่ได้ ถ้าต้องการ % จึงส่งด้วย XMLHttpRequest แทน
// คืนค่าหน้าตาเหมือน Response ของ fetch เท่าที่ POST ใช้ (headers.get, json)
const fetchWithUploadProgress = (url, init, onProgress) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(init.method, url);
    Object.entries(init.headers || {}).forEach(([name, value]) => xhr.setRequestHeader(name, value));
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && event.total > 0) onProgress(Math.round((event.loaded / event.total) * 100));
    };
    xhr.onload = () => {
      onProgress(100);
      resolve({
        headers: { get: (name) => xhr.getResponseHeader(name) },
        json: () => JSON.parse(xhr.responseText),
      });
    };
    xhr.onerror = reject;
    xhr.onabort = reject;
    xhr.ontimeout = reject;
    xhr.send(init.body);
  });

// options.onProgress(percent): รับ % ความคืบหน้าการอัปโหลด body (0-100) ใช้กับ request ที่แนบไฟล์/ข้อมูลก้อนใหญ่
const POST = async (url, body, extraHeaders, options) => {
  return new Promise((resolve) => {
    const send = typeof options?.onProgress === "function"
      ? (apiUrl, init) => fetchWithUploadProgress(apiUrl, init, options.onProgress)
      : fetch;
    send(url.includes("://") ? url : (process.env.REACT_APP_API_URL + url).replaceAll(" ", ""), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: getAccessToken(),
        token: CreateToken(),
        ...(extraHeaders || {}),
      },
      cache: "no-cache",
      body: JSON.stringify((options?.keepEmpty ? body : removeEmptyString(body)) ?? {}),
    })
      .then((response) => {
        saveRefreshedToken(response.headers.get(REFRESH_TOKEN_HEADER));
        return response.json();
      })
      .then((result) => {
        if (result.status === true) {
          resolve(result);
          return;
        }
        const message = ERROR(result);
        if (message === "User not verified, please verify your account first") {
          resolve({ status: false, message });
          return;
        }
        handleApiFailure(result, resolve, options);
      })
      .catch(() => {
        resolve(networkFailure());
      });
  });
};
const PUT = async (url, body, extraHeaders, options) => {
  return new Promise((resolve) => {
    fetch(url.includes("://") ? url : (process.env.REACT_APP_API_URL + url).replaceAll(" ", ""), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: getAccessToken(),
        token: CreateToken(),
        ...(extraHeaders || {}),
      },
      cache: "no-cache",
      body: JSON.stringify((options?.keepEmpty ? body : removeEmptyString(body)) ?? {}),
    })
      .then((response) => {
        saveRefreshedToken(response.headers.get(REFRESH_TOKEN_HEADER));
        return response.json();
      })
      .then((result) => {
        if (result.status === true) {
          resolve(result);
          return;
        }
        handleApiFailure(result, resolve);
      })
      .catch(() => {
        resolve(networkFailure());
      });
  });
};
const DELETE = async (url, body, extraHeaders) => {
  return new Promise((resolve) => {
    fetch(url.includes("://") ? url : (process.env.REACT_APP_API_URL + url).replaceAll(" ", ""), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: getAccessToken(),
        token: CreateToken(),
        ...(extraHeaders || {}),
      },
      cache: "no-cache",
    })
      .then((response) => {
        saveRefreshedToken(response.headers.get(REFRESH_TOKEN_HEADER));
        return response.json();
      })
      .then((result) => {
        if (result.status === true) {
          resolve(result);
          return;
        }
        handleApiFailure(result, resolve);
      })
      .catch(() => {
        resolve(networkFailure());
      });
  });
};
const ERROR = (result) => {
  loading(false);
  if (!result) return "";
  if (result.detail) {
    return result.detail;
  }
  if (result.data) {
    if (result.data.message) {
      return result.data.message;
    }
    return result.data;
  }
  return result.message || "";
};
const random_charactor = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  return Array.from({ length }, () =>
    characters.charAt(Math.floor(Math.random() * characters.length))
  ).join("");
};
// percent: ส่งตัวเลข 0-100 มาด้วยเมื่อต้องการแสดง % ความคืบหน้าใต้ spinner (เช่นตอนอัปโหลด) ปิด loading แล้วตัวเลขจะถูกล้างเอง
const loading = (status, percent) => {
  try {
    const loading = document.getElementById("loading");
    const progress = document.getElementById("loading-progress");
    if (status === true) {
      loading.classList.remove("d-none");
    } else if (status === false) {
      loading.classList.add("d-none");
    }
    if (progress) {
      const showPercent = status === true && typeof percent === "number";
      const value = showPercent ? Math.min(100, Math.max(0, Math.round(percent))) : 0;
      document.getElementById("loading-progress-bar").style.width = `${value}%`;
      document.getElementById("loading-percent").textContent = showPercent ? `${value}%` : "";
      progress.classList.toggle("d-none", !showPercent);
    }
  } catch (e) {}
};
const Status = (status, color, icon) => {
  return (
    <div className="d-flex">
      <span
        className={`bg-${color || "primary"}-light text-${
          color || "primary"
        } border-status-${
          color || "primary"
        } px-2 pt-0 rounded-4 text-nowrap d-flex text-12 mx-1`}
        style={{ padding: "2px 0 0 2px" }}
      >
        {status}
        {icon && (
          <span className={`icon ms-1 text-${color || "primary"}`}>{icon}</span>
        )}
      </span>
    </div>
  );
};
const params = (name) => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(name);
};
// แปลงค่าวันที่ (string "YYYY-MM-DD" / Date) เป็น Date ท้องถิ่นเวลา 00:00 ของวันนั้น
// ไม่ใช้ new Date("YYYY-MM-DD") ตรง ๆ เพราะจะตีความเป็น UTC ทำให้วันเพี้ยนได้ 1 วัน
const parseLocalDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
};

// ตัวเลือกวันที่มาตรฐานของระบบ (ภาษาไทย) value/onChange เป็น "YYYY-MM-DD" แสดงผล dd/mm/yyyy (ปี ค.ศ. ตามมาตรฐาน format_date)
// props: value, onChange(iso), min, max, className, style, disabled, placeholder, clearable (false = ซ่อนปุ่มล้าง), type="th" = โชว์ปี พ.ศ.
class DatePicker extends Component {
  state = {
    value: "",
    default: new Date(),
    array_date: [],
    array_month: [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ],
    array_year: [],
    showCalendar: false,
    calendarPos: { top: 0, left: 0 },
    min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
    max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
  };
  componentDidMount = () => {
    let year = [];
    for (let i = -100; i < 100; i++) {
      year.push(new Date().getFullYear() + i);
    }
    this.setState({ array_year: year });
    if (this.props.value) {
      this.setState({
        default: parseLocalDate(this.props.value),
        value: parseLocalDate(this.props.value),
      });
    }
    if (this.props.min) {
      this.setState({ min: parseLocalDate(this.props.min) });
    } else {
      this.setState({
        min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
      });
    }
    if (this.props.max) {
      this.setState({ max: parseLocalDate(this.props.max) });
    } else {
      this.setState({
        max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
      });
    }
    this.getDates();
  };
  componentWillReceiveProps = (props) => {
    if (props.min) {
      this.setState({ min: parseLocalDate(props.min) });
    } else {
      this.setState({
        min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
      });
    }
    if (props.max) {
      this.setState({ max: parseLocalDate(props.max) });
    } else {
      this.setState({
        max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
      });
    }
    // ค่าจาก parent เปลี่ยน (เช่น กดล้างฟอร์ม/เปิดแก้ไขรายการอื่น) ค่อยซิงก์ ถ้าเท่าเดิมไม่แตะ state จะได้ไม่ทับข้อความที่กำลังพิมพ์
    if (props.value !== this.props.value) {
      if (props.value) {
        this.setState({
          default: parseLocalDate(props.value),
          value: parseLocalDate(props.value),
        });
      } else {
        this.setState({ default: new Date(), value: "" });
      }
    }
  };
  onChangeDate = (option) => {
    if (option === "") {
      this.props.onChange("");
    } else {
      this.props.onChange(
        Number(option.getFullYear()) +
          "-" +
          ("0" + (Number(option.getMonth()) + 1)).slice(-2) +
          "-" +
          ("0" + option.getDate()).slice(-2)
      );
    }
    this.setState({ value: option, showCalendar: false });
  };
  getDates = () => {
    let dates = [];
    let date = new Date(
      this.state.default.getFullYear(),
      this.state.default.getMonth(),
      1
    );
    for (let d = 0; d < new Date(date).getDay(); d++) {
      dates.push("");
    }
    while (date.getMonth() === this.state.default.getMonth()) {
      dates.push(new Date(date).getDate());
      date.setDate(date.getDate() + 1);
    }
    this.setState({ array_date: dates });
  };
  inputRef = React.createRef();
  wrapperRef = React.createRef();
  calendarRef = React.createRef();
  // ปิดปฏิทินเมื่อกดนอก input/ปฏิทิน (ใช้ mousedown ที่ document แทน overlay ทับจอ
  // เพราะ overlay ที่โผล่ใต้เมาส์ตอน mousedown ทำให้ click ไปตกที่ .modal แล้ว react-bootstrap ปิด modal)
  handleOutsideMouseDown = (e) => {
    const t = e.target;
    if (this.wrapperRef.current && this.wrapperRef.current.contains(t)) return;
    if (this.calendarRef.current && this.calendarRef.current.contains(t)) return;
    this.setState({ showCalendar: false });
  };
  // ปฏิทินถูก render ผ่าน portal (position: fixed) จะได้ไม่โดน overflow:hidden ของ modal-content / table-responsive ตัดทิ้ง
  // ถ้า input อยู่ใน modal จะ portal ไปที่ .modal ตัวนั้น (ไม่ใช่ body) เพราะ react-bootstrap จะดึง focus กลับเข้า modal
  // ถ้า focus หลุดออกไปนอก dialog ทำให้ select เดือน/ปี ในปฏิทินกดไม่ได้
  getPortalTarget = () => {
    const input = this.inputRef.current;
    return (input && input.closest(".modal")) || document.body;
  };
  updateCalendarPosition = () => {
    const input = this.inputRef.current;
    if (!input) return;
    const rect = input.getBoundingClientRect();
    const CAL_W = 300;
    const CAL_H = 335;
    const GAP = 4;
    let left = rect.left;
    let top = rect.bottom + GAP;
    if (left + CAL_W > window.innerWidth) left = Math.max(8, rect.right - CAL_W);
    if (top + CAL_H > window.innerHeight) top = Math.max(8, rect.top - CAL_H - GAP);
    this.setState({ calendarPos: { top, left } });
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.state.showCalendar && !prevState.showCalendar) {
      window.addEventListener("scroll", this.updateCalendarPosition, true);
      window.addEventListener("resize", this.updateCalendarPosition);
      document.addEventListener("mousedown", this.handleOutsideMouseDown, true);
      document.addEventListener("touchstart", this.handleOutsideMouseDown, true);
    } else if (!this.state.showCalendar && prevState.showCalendar) {
      this.removeCalendarListeners();
    }
  }
  removeCalendarListeners = () => {
    window.removeEventListener("scroll", this.updateCalendarPosition, true);
    window.removeEventListener("resize", this.updateCalendarPosition);
    document.removeEventListener("mousedown", this.handleOutsideMouseDown, true);
    document.removeEventListener("touchstart", this.handleOutsideMouseDown, true);
  };
  componentWillUnmount() {
    this.removeCalendarListeners();
  }
  render() {
    return (
      <div
        ref={this.wrapperRef}
        title={this.props.title}
        style={{
          position: "relative",
          width: "100%",
          fontSize: "0.8rem",
          ...(this.props.style || {}),
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ position: "relative" }}>
            <input
              ref={this.inputRef}
              id={this.props.id}
              name={this.props.name}
              className={this.props.className}
              style={{ cursor: "pointer", paddingRight: 32 }}
              type="text"
              value={
                this.state.value && typeof this.state.value === "object"
                  ? ("0" + this.state.value.getDate()).slice(-2) +
                    "/" +
                    ("0" + (Number(this.state.value.getMonth()) + 1)).slice(
                      -2
                    ) +
                    "/" +
                    Number(this.state.value.getFullYear())
                  : this.state.value
              }
              placeholder={
                this.props.placeholder ? this.props.placeholder : "dd/mm/yyyy"
              }
              onFocus={() => {
                this.updateCalendarPosition();
                this.setState({
                  showCalendar: true,
                  default: this.state.value
                    ? new Date(this.state.value)
                    : new Date(),
                });
                setTimeout(() => {
                  this.getDates();
                }, 1);
              }}
              onChange={(e) => {
                this.setState({ value: e.target.value });
              }}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  e.target.blur();
                }
              }}
              onBlur={() => {
                const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
                if (regex.test(this.state.value)) {
                  this.setState({
                    default: new Date(
                      Number(this.state.value.split("/")[2]) > 2100
                        ? Number(this.state.value.split("/")[2]) - 543
                        : Number(this.state.value.split("/")[2]),
                      Number(this.state.value.split("/")[1]) - 1,
                      Number(this.state.value.split("/")[0])
                    ),
                  });
                  setTimeout(() => {
                    this.onChangeDate(
                      new Date(
                        this.state.default.getFullYear(),
                        this.state.default.getMonth(),
                        this.state.default.getDate()
                      )
                    );
                  }, 10);
                } else if (
                  typeof this.state.value === "object" &&
                  this.state.value !== "Invalid Date"
                ) {
                  console.log("Invalid Date");
                } else if (
                  this.state.value.length === 8 &&
                  Number(this.state.value)
                ) {
                  this.setState({
                    default: new Date(
                      Number(this.state.value.slice(-4)) > 2100
                        ? Number(this.state.value.slice(-4)) - 543
                        : Number(this.state.value.slice(-4)),
                      Number(this.state.value.slice(2, 4)) - 1,
                      Number(this.state.value.slice(0, 2))
                    ),
                  });
                  setTimeout(() => {
                    this.onChangeDate(
                      new Date(
                        this.state.default.getFullYear(),
                        this.state.default.getMonth(),
                        this.state.default.getDate()
                      )
                    );
                  }, 10);
                } else {
                  this.setState({ value: "" });
                }
              }}
              disabled={this.props.disabled}
              maxLength={10}
            />
            <svg
              style={{ position: "absolute", right: 12, top: 8 }}
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#d2d2d2"
              viewBox="0 0 448 512"
            >
              <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z" />
            </svg>
          </div>
          {this.state.showCalendar &&
            createPortal(
            <div
              ref={this.calendarRef}
              id="calendar"
              style={{
                zIndex: 2001,
                width: 300,
                position: "fixed",
                top: this.state.calendarPos.top,
                left: this.state.calendarPos.left,
                fontSize: "0.8rem",
                paddingTop: "0.3rem",
                paddingBottom: "0.3rem",
                display: "flex",
                flexDirection: "column",
                minWidth: 0,
                wordWrap: "break-word",
                backgroundColor: "#ffffff",
                backgroundClip: "border-box",
                border: "1px solid rgba(0,0,0,.125)",
                borderRadius: 8,
                boxShadow: "0 0.3rem 1rem rgba(0, 0, 0, .15)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {this.state.default.getMonth() === 0 &&
                this.state.default.getFullYear() ===
                  new Date().getFullYear() - 100 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                    width="12"
                    height="12"
                    fill="#e1e2e2"
                  >
                    <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                  </svg>
                ) : (
                  <span
                    style={{ cursor: "pointer", padding: "1rem" }}
                    onClick={() => {
                      let date = this.state.default;
                      date.setMonth(date.getMonth() - 1);
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                      width="12"
                      height="12"
                    >
                      <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                    </svg>
                  </span>
                )}
                {/* เดือน */}
                <select
                  style={{ width: 100, borderWidth: 0, textAlign: "center" }}
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setMonth(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={
                    this.state.default ? this.state.default.getMonth() : " "
                  }
                >
                  {this.state.array_month.map((item, index) => (
                    <option key={`array-${index}`} value={index}>
                      {item}
                    </option>
                  ))}
                </select>
                <label
                  style={{
                    marginLeft: "0.3rem",
                    marginRight: "0.3rem",
                    paddingBottom: 0,
                    cursor: "pointer",
                  }}
                >
                  {this.props.type === "th" ? "พ.ศ." : "ค.ศ."}
                </label>
                {/* ปี */}
                <select
                  style={{ width: 60, borderWidth: 0, textAlign: "center" }}
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setFullYear(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={
                    this.state.default ? this.state.default.getFullYear() : " "
                  }
                >
                  {this.state.array_year.map((item, index) => (
                    <option key={`array-${index}`} value={item}>
                      {this.props.type === "th" ? item + 543 : item}{" "}
                    </option>
                  ))}
                </select>
                {this.state.default.getMonth() === 11 &&
                this.state.default.getFullYear() ===
                  new Date().getFullYear() + 99 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                    width="12"
                    height="12"
                    fill="#e1e2e2"
                  >
                    <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                  </svg>
                ) : (
                  <span
                    style={{ cursor: "pointer", padding: "1rem" }}
                    onClick={() => {
                      let date = this.state.default;
                      date.setMonth(date.getMonth() + 1);
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                      width="12"
                      height="12"
                    >
                      <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                    </svg>
                  </span>
                )}
              </div>
              <div
                style={{
                  marginBottom: "1rem",
                  marginLeft: 0,
                  marginRight: 0,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"].map(
                  (item, index) => (
                    <div
                      key={"day_" + index}
                      style={{
                        width: "14.28%",
                        padding: "0,25rem 0",
                        textAlign: "center",
                      }}
                    >
                      {item}
                    </div>
                  )
                )}
              </div>
              <div
                style={{
                  marginTop: "-1rem",
                  marginLeft: 0,
                  marginRight: 0,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  height: 220,
                }}
              >
                {this.state.array_date.map((item, index) => (
                  <div
                    key={"date_" + index}
                    style={
                      this.state.value &&
                      typeof this.state.value === "object" &&
                      item &&
                      this.state.value.getDate() === item &&
                      this.state.value.getMonth() ===
                        this.state.default.getMonth() &&
                      this.state.value.getFullYear() ===
                        this.state.default.getFullYear()
                        ? new Date(
                            this.state.default.getFullYear(),
                            this.state.default.getMonth(),
                            item
                          ) >= this.state.min.getTime() &&
                          new Date(
                            this.state.default.getFullYear(),
                            this.state.default.getMonth(),
                            item
                          ) <= this.state.max.getTime()
                          ? {
                              width: "14.28%",
                              paddingTop: "0.3rem",
                              paddingBottom: "0.3rem",
                              textAlign: "center",
                              cursor: "pointer",
                              backgroundColor: "#0d6efd",
                              color: "#ffffff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }
                          : {
                              width: "14.28%",
                              paddingTop: "0.3rem",
                              paddingBottom: "0.3rem",
                              textAlign: "center",
                              backgroundColor: "#0d6efd",
                              color: "#e1e2e2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }
                        : new Date(
                            this.state.default.getFullYear(),
                            this.state.default.getMonth(),
                            item
                          ) >= this.state.min.getTime() &&
                          new Date(
                            this.state.default.getFullYear(),
                            this.state.default.getMonth(),
                            item
                          ) <= this.state.max.getTime()
                        ? {
                            width: "14.28%",
                            paddingTop: "0.3rem",
                            paddingBottom: "0.3rem",
                            textAlign: "center",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }
                        : {
                            width: "14.28%",
                            paddingTop: "0.3rem",
                            paddingBottom: "0.3rem",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#e1e2e2",
                          }
                    }
                    onClick={() => {
                      if (
                        new Date(
                          this.state.default.getFullYear(),
                          this.state.default.getMonth(),
                          item
                        ) >= this.state.min.getTime() &&
                        new Date(
                          this.state.default.getFullYear(),
                          this.state.default.getMonth(),
                          item
                        ) <= this.state.max.getTime()
                      ) {
                        this.onChangeDate(
                          new Date(
                            this.state.default.getFullYear(),
                            this.state.default.getMonth(),
                            item
                          )
                        );
                      }
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingLeft: "0.3rem",
                  paddingRight: "0.3rem",
                }}
              >
                {this.props.clearable !== false ? (
                  <label
                    style={{ cursor: "pointer", color: "#0d6efd" }}
                    onClick={() => {
                      this.onChangeDate("");
                    }}
                  >
                    ล้าง
                  </label>
                ) : (
                  <label></label>
                )}
                <label
                  style={{ cursor: "pointer", color: "#0d6efd" }}
                  onClick={() => {
                    this.onChangeDate(new Date());
                  }}
                >
                  วันนี้
                </label>
              </div>
            </div>,
              this.getPortalTarget()
            )}
        </div>
      </div>
    );
  }
}
// ใช้แทน <input type="date"> ทั้งระบบ: รับ props แบบเดียวกับ input (name, value/defaultValue, onChange(event), min, max, style, disabled, readOnly)
// onChange จะได้ { target: { name, value: "YYYY-MM-DD" } } ทำให้ handleChange เดิมของแต่ละหน้าใช้ได้โดยไม่ต้องแก้
class DateInput extends Component {
  state = { value: this.props.defaultValue || "" };
  handleChange = (next) => {
    if (this.props.value === undefined) this.setState({ value: next });
    if (this.props.onChange) this.props.onChange({ target: { name: this.props.name, value: next, type: "date" } });
  };
  render() {
    const { value, defaultValue, onChange, readOnly, disabled, className, ...rest } = this.props;
    const current = value === undefined ? this.state.value : value || "";
    return <DatePicker {...rest} className={className || "form-control"} value={current} disabled={disabled || readOnly} onChange={this.handleChange} />;
  }
}

class DateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start_date: props.value?.start_date
        ? new Date(props.value.start_date)
        : null,
      end_date: props.value?.end_date ? new Date(props.value.end_date) : null,
      hoverDate: null,
      default: new Date(),
      array_date: [],
      array_month: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      array_year: [],
      showCalendar: false,
    };
    this.calendarRef = React.createRef();
    this.inputWrapperRef = React.createRef();
  }

  componentDidMount() {
    if (mode === "dark") {
          setDarkMode();
        }
    let year = [];
    for (let i = -100; i < 100; i++) {
      year.push(new Date().getFullYear() + i);
    }
    this.setState({ array_year: year });
    this.getDates();
  }

  componentDidUpdate(prevProps, prevState) {
    if (mode === "dark") {
          setDarkMode();
        }
    if (prevProps.value !== this.props.value) {
      this.setState({
        start_date: this.props.value?.start_date
          ? new Date(this.props.value.start_date)
          : null,
        end_date: this.props.value?.end_date
          ? new Date(this.props.value.end_date)
          : null,
      });
    }
    // ✅ ต้องเช็ค state ก่อน ไม่ใช่ props
    if (this.state.showCalendar && !prevState.showCalendar) {
      this.adjustCalendarPosition();
    }
  }

  adjustCalendarPosition = () => {
    const calendar = this.calendarRef.current;
    const inputWrapper = this.inputWrapperRef.current;
    if (!calendar || !inputWrapper) return;

    const rect = calendar.getBoundingClientRect();
    const inputRect = inputWrapper.getBoundingClientRect();
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    let style = {};

    // ถ้าล้นขวา → ขยับเข้ามา
    if (rect.right > screenWidth) {
      style.right = 0;
      style.left = "auto";
    }

    // ถ้าล้นล่าง → แสดงด้านบน input
    if (rect.bottom > screenHeight) {
      style.bottom = inputRect.height + 8; // 8px margin
      style.top = "auto";
      style.marginTop = 0;
    }

    Object.assign(calendar.style, style);
  };

  getDates = () => {
    let dates = [];
    let date = new Date(
      this.state.default.getFullYear(),
      this.state.default.getMonth(),
      1
    );
    for (let d = 0; d < date.getDay(); d++) {
      dates.push("");
    }
    while (date.getMonth() === this.state.default.getMonth()) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    this.setState({ array_date: dates });
  };

  handleDateClick = (date) => {
    const { start_date, end_date } = this.state;
    if (!start_date || (start_date && end_date)) {
      this.setState({ start_date: date, end_date: null }, () => {
        this.props.onChange?.({ start_date: date, end_date: null });
      });
    } else if (start_date && !end_date) {
      if (date >= start_date) {
        this.setState({ end_date: date }, () => {
          this.props.onChange?.({
            start_date: this.state.start_date,
            end_date: date,
          });
        });
      } else {
        this.setState({ start_date: date, end_date: start_date }, () => {
          this.props.onChange?.({ start_date: date, end_date: start_date });
        });
      }
    }
  };

  isInRange = (date) => {
    const { start_date, end_date, hoverDate } = this.state;
    if (!start_date) return false;

    if (start_date && !end_date && hoverDate) {
      return date >= start_date && date <= hoverDate;
    }

    if (start_date && end_date) {
      return date >= start_date && date <= end_date;
    }
    return false;
  };

  render() {
    const {
      array_date,
      array_month,
      default: current,
      start_date,
      end_date,
      showCalendar,
    } = this.state;

    return (
      <div
        style={{ position: "relative", width: "100%", fontSize: "0.8rem" }}
        ref={this.inputWrapperRef}
      >
        {showCalendar && (
          <div
            style={{
              bottom: 0,
              left: 0,
              top: 0,
              right: 0,
              backgroundColor: "#0000",
              zIndex: 1000,
              position: "fixed",
            }}
            onClick={() => this.setState({ showCalendar: false })}
          />
        )}

        {/* Input */}
        <div style={{ position: "relative" }}>
          <input
            className={this.props.className}
            readOnly
            type="text"
            onFocus={() => this.setState({ showCalendar: true })}
            value={
              start_date
                ? `${format_date(start_date)} - ${
                    end_date ? format_date(end_date) : ""
                  }`
                : ""
            }
            placeholder="เลือกช่วงวันที่"
            style={{ width: "100%", padding: "0.35rem 0.5rem" }}
          />
          <svg
            style={{ position: "absolute", right: 12, top: 8 }}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#d2d2d2"
            viewBox="0 0 448 512"
          >
            <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z" />
          </svg>
        </div>

        {/* Calendar */}
        {showCalendar && (
          <div
            id="calendar-range"
            ref={this.calendarRef}
            style={{
              zIndex: 1000,
              width: 320,
              position: "absolute",
              marginTop: "0.2rem",
              padding: "0.5rem",
              backgroundColor: "#fff",
              border: "1px solid rgba(0,0,0,.125)",
              borderRadius: 8,
              boxShadow: "0 0.3rem 1rem rgba(0,0,0,.15)",
              top: "100%",
              left: 0,
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "0.5rem",
              }}
            >
              <span
                style={{ cursor: "pointer", padding: "1rem" }}
                onClick={() => {
                  let d = new Date(current);
                  d.setMonth(d.getMonth() - 1);
                  this.setState({ default: d }, this.getDates);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  width="12"
                  height="12"
                  fill={mode === "dark" ? "#ffffff": "#000000"}
                >
                  <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                </svg>
              </span>
              <div>
                {array_month[current.getMonth()]} {current.getFullYear()}
              </div>
              <span
                style={{ cursor: "pointer", padding: "1rem" }}
                onClick={() => {
                  let d = new Date(current);
                  d.setMonth(d.getMonth() + 1);
                  this.setState({ default: d }, this.getDates);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  width="12"
                  height="12"
                  fill={mode === "dark" ? "#ffffff": "#000000"}
                >
                  <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                </svg>
              </span>
            </div>

            {/* Day headers */}
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"].map((d, i) => (
                <div
                  key={i}
                  style={{
                    width: "14.28%",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {d}
                </div>
              ))}
            </div>

            {/* Dates */}
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {array_date.map((date, idx) => {
                if (!date)
                  return (
                    <div
                      key={idx}
                      style={{ width: "14.28%", height: 30 }}
                    ></div>
                  );

                const isSelected =
                  (start_date &&
                    date.toDateString() === start_date.toDateString()) ||
                  (end_date && date.toDateString() === end_date.toDateString());

                const isInRange = this.isInRange(date);

                return (
                  <div
                    key={idx}
                    style={{
                      width: "14.28%",
                      height: 30,
                      textAlign: "center",
                      lineHeight: "30px",
                      margin: "2px 0",
                      backgroundColor: isSelected
                        ? "#0d6efd"
                        : isInRange
                        ? "rgba(13,110,253,0.3)"
                        : "transparent",
                      color: isSelected ? "#fff" : mode === "dark" ? "#ffffff": "#000000",
                      cursor: "pointer",
                      borderTopLeftRadius:
                        start_date &&
                        date.toDateString() === start_date.toDateString()
                          ? 12
                          : 0,
                      borderBottomLeftRadius:
                        start_date &&
                        date.toDateString() === start_date.toDateString()
                          ? 12
                          : 0,
                      borderTopRightRadius:
                        end_date &&
                        date.toDateString() === end_date.toDateString()
                          ? 12
                          : 0,
                      borderBottomRightRadius:
                        end_date &&
                        date.toDateString() === end_date.toDateString()
                          ? 12
                          : 0,
                    }}
                    onClick={() => this.handleDateClick(date)}
                    onMouseEnter={() => this.setState({ hoverDate: date })}
                    onMouseLeave={() => this.setState({ hoverDate: null })}
                  >
                    {date.getDate()}
                  </div>
                );
              })}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "0.3rem",
                paddingRight: "0.3rem",
                marginTop: "0.5rem",
              }}
            >
              {this.props.clearable !== false ? (
                <label
                  style={{ cursor: "pointer", color: "#0d6efd" }}
                  onClick={() => {
                    this.setState({ start_date: null, end_date: null });
                    this.props.onChange?.({ start_date: null, end_date: null });
                  }}
                >
                  ล้าง
                </label>
              ) : (
                <label></label>
              )}
              <label
                style={{ cursor: "pointer", color: "#0d6efd" }}
                onClick={() => {
                  this.setState({ start_date: new Date(), end_date: null });
                  this.props.onChange?.({
                    start_date: new Date(),
                    end_date: null,
                  });
                }}
              >
                วันนี้
              </label>
            </div>
          </div>
        )}
      </div>
    );
  }
}
class Select extends Component {
  state = {
    showSelectOption: false,
    search: "",
    selected: "",
  };
  componentDidMount = () => {};
  componentWillReceiveProps = (props) => {};
  render() {
    return (
      <div
        style={{ position: "relative", padding: 0 }}
        className={this.props.className}
      >
        {this.state.showSelectOption && (
          <div
            style={{
              bottom: 0,
              left: 0,
              top: 0,
              right: 0,
              backgroundColor: "#0000",
              zIndex: 1000,
              position: "fixed",
            }}
            onClick={() => {
              this.setState({ showSelectOption: false });
            }}
          ></div>
        )}
        <div style={{ position: "relative" }}>
          {!this.state.search &&
          !this.state.showSelectOption &&
          this.props.options?.find((e) => e.value === this.props.value)
            ?.front ? (
            <div className="position-absolute mx-2 mt-1">
              {
                this.props.options?.find((e) => e.value === this.props.value)
                  ?.front
              }
            </div>
          ) : null}
          <input
            className={this.props.className
              ?.replaceAll("mb-2", "")
              .replaceAll("mb-3", "")
              .replaceAll("mb-4", "")
              .replaceAll("mb-5", "")}
            style={{
              width: "100%",
              backgroundColor: this.props.disabled ? "#e9ecef" : "#00000000",
              border: 0,
              paddingLeft:
                !this.state.search &&
                !this.state.showSelectOption &&
                this.props.options?.find((e) => e.value === this.props.value)
                  ?.front
                  ? 36
                  : ".75rem",
            }}
            type="text"
            value={
              !this.state.search &&
              !this.state.showSelectOption &&
              this.props.value
                ? this.props.options?.find((e) => e.value === this.props.value)
                    ?.label
                : this.state.search
            }
            placeholder={this.props.placeholder || ""}
            onFocus={() => {
              this.setState({
                showSelectOption: true,
                search: "",
                selected: "",
              });
            }}
            onChange={(e) => {
              this.setState({ search: e.target.value });
            }}
            disabled={this.props.disabled}
          />
          <div
            style={{
              display: "flex",
              position: "absolute",
              right: 8,
              top: "50%",
            }}
          >
            <div
              style={{
                width: 7,
                height: 1.7,
                backgroundColor: "#232323",
                transform: "rotate(45deg)",
                borderRadius: 1,
              }}
            ></div>
            <div
              style={{
                width: 7,
                height: 1.7,
                backgroundColor: "#232323",
                transform: "rotate(315deg)",
                marginLeft: -3.2,
                borderRadius: 1,
              }}
            ></div>
          </div>
        </div>
        {this.state.showSelectOption && (
          <div
            id="select-tool"
            style={{
              minWidth: 150,
              width: "100%",
              padding: 6,
              borderRadius: 6,
              borderWidth: 1,
              borderColor: "#d2d2d2",
              borderStyle: "solid",
              backgroundColor: mode === "dark" ? "#3c3e43ff" : "#fdfdfd",
              position: "absolute",
              top: 40,
              zIndex: 1001,
            }}
          >
            <div
              style={{
                maxHeight: 400,
                overflowY: "auto",
                overflowX: "hidden",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {this.props.options?.filter(
                (e) => !this.state.search || e.label.includes(this.state.search)
              ).length !== 0 &&
                this.props.default !== false && (
                  <div
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      padding: 4,
                      backgroundColor:
                        this.state.selected === "" ? "#dfdfdf" : "#fff0",
                      color:
                        mode === "dark"
                          ? this.state.selected === ""
                            ? "#000000"
                            : "#dfdfdf"
                          : "#000000",
                    }}
                    onClick={() => {
                      this.setState({
                        showSelectOption: false,
                        search: "",
                        selected: "",
                      });
                      this.props.onChange("", { value: "", label: "" });
                    }}
                    onMouseEnter={() => this.setState({ selected: "" })}
                  >
                    -- กรุณาเลือก --
                  </div>
                )}
              {this.props.options
                ?.filter(
                  (e) =>
                    !this.state.search || e.label.includes(this.state.search)
                )
                .map((item, index) => (
                  <div
                    key={`array-${index}`}
                    style={{
                      display: "flex",
                      width: "100%",
                      cursor: "pointer",
                      padding: 4,
                      backgroundColor:
                        this.state.selected === item.value
                          ? "#dfdfdf"
                          : "#fff0",
                      color:
                        mode === "dark"
                          ? this.state.selected === item.value
                            ? "#000000"
                            : "#dfdfdf"
                          : "#000000",
                    }}
                    onClick={() => {
                      this.setState({
                        showSelectOption: false,
                        search: "",
                        selected: "",
                      });
                      this.props.onChange(item.value, item);
                    }}
                    onMouseEnter={() => this.setState({ selected: item.value })}
                  >
                    {item.front || ""}
                    {item.label}
                  </div>
                ))}
              <div>
                {this.props.options?.filter(
                  (e) =>
                    !this.state.search || e.label.includes(this.state.search)
                ).length === 0 && (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "#2c2c2c",
                    }}
                  >
                    ไม่พบข้อมูล...
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
class BtnIcon extends Component {
  render() {
    return (
      <div>
        {this.props.type === "print" && (
          <div
            className={`status bg-primary-light wpx-25 hpx-25 icon px-1 pointer text-primary ${this.props.className}`}
            title={this.props.title || "Print"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf02f"}
          </div>
        )}
        {this.props.type === "view" && (
          <div
            className={`status bg-success-light wpx-25 hpx-25 icon px-1 pointer text-success ${this.props.className}`}
            title={this.props.title || "View"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf06e"}
          </div>
        )}
        {this.props.type === "download" && (
          <div
            className={`status bg-info-light wpx-25 hpx-25 icon px-1 pointer text-info ${this.props.className}`}
            title={this.props.title || "Download"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf019"}
          </div>
        )}
        {this.props.type === "email" && (
          <div
            className={`status bg-secondary-light wpx-25 hpx-25 icon px-1 pointer text-secondary ${this.props.className}`}
            title={this.props.title || "Send Email"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf0e0"}
          </div>
        )}
        {this.props.type === "update" && (
          <div
            className={`status bg-warning-light wpx-25 hpx-25 icon px-1 pointer text-orange ${this.props.className}`}
            title={this.props.title || "Update"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf044"}
          </div>
        )}
        {this.props.type === "approve" && (
          <div
            className={`status bg-purple-light wpx-25 hpx-25 icon px-1 pointer text-purple ${this.props.className}`}
            title={this.props.title || "Change Status"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf52d"}
          </div>
        )}
        {this.props.type === "delete" && (
          <div
            className={`status bg-danger-light wpx-25 hpx-25 icon px-1 pointer text-danger ${this.props.className}`}
            title={this.props.title || "Delete"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf1f8"}
          </div>
        )}
        {this.props.type === "inquiry" && (
          <div
            className={`status bg-info-light wpx-25 hpx-25 icon px-1 pointer text-info ${this.props.className}`}
            title={this.props.title || "Inquiry"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf688"}
          </div>
        )}
        {this.props.type === "callback" && (
          <div
            className={`status bg-secondary-light wpx-25 hpx-25 icon px-1 pointer text-dark ${this.props.className}`}
            title={this.props.title || "Callback"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\u0043"}
          </div>
        )}
        {this.props.type === "recalc" && (
          <div
            className={`status bg-info-light wpx-25 hpx-25 icon px-1 pointer text-info ${this.props.className}`}
            title={this.props.title || "Recalculate"}
            onClick={() => {
              this.props.onClick();
            }}
          >
            {"\uf2f1"}
          </div>
        )}
      </div>
    );
  }
}
const setDarkMode = () => {
  // document.getElementsByClassName("body")[0].classList.add("bg-light")
  document.getElementById("root").style = "background-color:#111317";

  const root = document.documentElement;

  // Base colors
  root.style.setProperty("--bs-blue", "#4dabf7");
  root.style.setProperty("--bs-indigo", "#9b8af9");
  root.style.setProperty("--bs-purple", "#b197fc");
  root.style.setProperty("--bs-pink", "#f06595");
  root.style.setProperty("--bs-red", "#ff6b6b");
  root.style.setProperty("--bs-orange", "#ffa94d");
  root.style.setProperty("--bs-yellow", "#ffd43b");
  root.style.setProperty("--bs-green", "#51cf66");
  root.style.setProperty("--bs-teal", "#38d9a9");
  root.style.setProperty("--bs-cyan", "#66d9e8");

  // Black/white invert
  root.style.setProperty("--bs-black", "#f8f9fa");
  root.style.setProperty("--bs-white", "#121212");

  // Grays
  root.style.setProperty("--bs-gray", "#adb5bd");
  root.style.setProperty("--bs-gray-dark", "#e9ecef");
  root.style.setProperty("--bs-gray-100", "#212529");
  root.style.setProperty("--bs-gray-200", "#2c2f36");
  root.style.setProperty("--bs-gray-300", "#343a40");
  root.style.setProperty("--bs-gray-400", "#495057");
  root.style.setProperty("--bs-gray-500", "#6c757d");
  root.style.setProperty("--bs-gray-600", "#868e96");
  root.style.setProperty("--bs-gray-700", "#adb5bd");
  root.style.setProperty("--bs-gray-800", "#dee2e6");
  root.style.setProperty("--bs-gray-900", "#f1f3f5");

  // Context colors
  root.style.setProperty("--bs-primary", "#4dabf7"); // ปุ่มหลัก
  root.style.setProperty("--bs-secondary", "#868e96"); // ปุ่มรอง
  root.style.setProperty("--bs-success", "#51cf66"); // สำเร็จ
  root.style.setProperty("--bs-info", "#66d9e8"); // ข้อมูล
  root.style.setProperty("--bs-warning", "#ffd43b"); // เตือน
  root.style.setProperty("--bs-danger", "#ff6b6b"); // อันตราย
  root.style.setProperty("--bs-light", "#212529"); // สีพื้นหลัง / light elements
  root.style.setProperty("--bs-dark", "#f1f3f5"); // สีข้อความ / dark elements

  // RGB variants
  root.style.setProperty("--bs-primary-rgb", "77, 171, 247");
  root.style.setProperty("--bs-secondary-rgb", "173, 181, 189");
  root.style.setProperty("--bs-success-rgb", "81, 207, 102");
  root.style.setProperty("--bs-info-rgb", "102, 217, 232");
  root.style.setProperty("--bs-warning-rgb", "255, 212, 59");
  root.style.setProperty("--bs-danger-rgb", "255, 107, 107");
  root.style.setProperty("--bs-light-rgb", "44, 44, 44");
  root.style.setProperty("--bs-dark-rgb", "222, 222, 222");

  // Emphasis text
  root.style.setProperty("--bs-secondary-light", "#4c5158ff");

  root.style.setProperty("--bs-primary-text-emphasis", "#bac8ff");
  root.style.setProperty("--bs-secondary-text-emphasis", "#ced4da");
  root.style.setProperty("--bs-success-text-emphasis", "#b2f2bb");
  root.style.setProperty("--bs-info-text-emphasis", "#a5f3fc");
  root.style.setProperty("--bs-warning-text-emphasis", "#ffe066");
  root.style.setProperty("--bs-danger-text-emphasis", "#ffa8a8");
  root.style.setProperty("--bs-light-text-emphasis", "#dee2e6");
  root.style.setProperty("--bs-dark-text-emphasis", "#f8f9fa");

  // Subtle backgrounds
  root.style.setProperty("--bs-primary-bg-subtle", "#0b2139");
  root.style.setProperty("--bs-secondary-bg-subtle", "#1d1f21");
  root.style.setProperty("--bs-success-bg-subtle", "#0f2e1a");
  root.style.setProperty("--bs-info-bg-subtle", "#0a2c34");
  root.style.setProperty("--bs-warning-bg-subtle", "#332b0a");
  root.style.setProperty("--bs-danger-bg-subtle", "#3a1515");
  root.style.setProperty("--bs-light-bg-subtle", "#1a1a1a");
  root.style.setProperty("--bs-dark-bg-subtle", "#2c2c2c");

  // Subtle borders
  root.style.setProperty("--bs-primary-border-subtle", "#1c3d5a");
  root.style.setProperty("--bs-secondary-border-subtle", "#2e3236");
  root.style.setProperty("--bs-success-border-subtle", "#1f5133");
  root.style.setProperty("--bs-info-border-subtle", "#1d5966");
  root.style.setProperty("--bs-warning-border-subtle", "#665214");
  root.style.setProperty("--bs-danger-border-subtle", "#663333");
  root.style.setProperty("--bs-light-border-subtle", "#2c2c2c");
  root.style.setProperty("--bs-dark-border-subtle", "#444");

  // Body + link
  root.style.setProperty("--bs-body-color", "#f8f9fa");
  root.style.setProperty("--bs-body-bg", "#121212");
  root.style.setProperty("--bs-link-color", "#4dabf7");
  root.style.setProperty("--bs-link-hover-color", "#74c0fc");

  root.style.setProperty("--placeholder-color", "#ffffffff");

  root.style.setProperty("--bs-gray-1", "#3c3e43ff");
  root.style.setProperty("--bs-table-color-state", "#fff");

  root.style.setProperty("--bs-dropdown-link-hover-bg", "#3c3e43ff");
  root.style.setProperty("--bs-btn-close-color", "#ffffff");

  root.style.setProperty("--bs-white-rgb", "44,44,44");

  document.querySelectorAll(".btn-dark").forEach((thead) => {
    thead.style = "color:#000000;background-color:#f1f3f5;";
  });
  document.querySelectorAll(".btn-light").forEach((thead) => {
    thead.style = "color:#ffffff;background-color:#2c2c2c;";
  });
  document.querySelectorAll(".btn-outline-dark").forEach((thead) => {
    thead.style = "color:#f1f3f5;border-color:#f1f3f5;";
  });
  document.querySelectorAll(".btn-close").forEach((btn) => {
    btn.classList.add("btn-close-white");
  });
  document.querySelectorAll(".modal-content").forEach((btn) => {
    btn.classList.add("border-secondary-light");
  });
  document.querySelectorAll(".rounded-3.bg-white").forEach((btn) => {
    btn.classList.add("border-1");
    btn.classList.add("border-secondary-light");
  });
  document.querySelectorAll("#calendar").forEach((btn) => {
    btn.classList.add("bg-light");
  });
  document.querySelectorAll("#calendar select").forEach((btn) => {
    btn.classList.add("bg-light");
    btn.classList.add("text-dark");
  });
  document.querySelectorAll("#calendar-range").forEach((btn) => {
    btn.classList.add("bg-light");
  });
  document.querySelectorAll("#calendar-range select").forEach((btn) => {
    btn.classList.add("bg-light");
    btn.classList.add("text-dark");
  });
  document.querySelectorAll("tbody tr td").forEach((btn) => {
    btn.classList.add("bg-light");
  });
  document.querySelectorAll("thead tr td").forEach((btn) => {
    btn.classList.add("bg-light");
  });
  document.querySelectorAll("tfoot tr td").forEach((btn) => {
    btn.classList.add("bg-light");
  });

  document.querySelectorAll("td").forEach((thead) => {
    thead.style = "color:#ffffff;";
  });
  document.querySelectorAll("th").forEach((thead) => {
    thead.style = "color:#ffffff;";
  });
  document.querySelectorAll(".dropdown-item").forEach((btn) => {
    btn.addEventListener("mouseenter", () => {
      btn.classList.add("text-light"); // เมื่อ mouse hover
    });
    btn.addEventListener("mouseleave", () => {
      btn.classList.remove("text-light"); // เมื่อ mouse ออกจาก element
    });
  });
};
export {
  profile,
  tokens,
  twofa,
  mode,
  linkRole,
  StatusTnx,
  copyText,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  saveRefreshedToken,
  REFRESH_TOKEN_HEADER,
  refreshAccessToken,
  startTokenRefreshScheduler,
  preserveClientPrefs as clearAuthStorage,
  loading,
  Status,
  params,
  setDarkMode,
  required,
  DatePicker,
  DateInput,
  DateRangePicker,
  Select,
  BtnIcon,
};
export { default as Swal } from "sweetalert2";
export { default as Pagination } from "@mui/material/Pagination";
export { default as Switch } from "react-switch";
export { default as Navbar } from "../components/Navbar.js";
export { Modal } from "react-bootstrap";
export { default as Resizer } from "react-image-file-resizer";
export { saveAs } from "file-saver";
export * as XLSX from "xlsx";
